export const _setAssetTags = (state, action) => {
  state.assetTags = [...state.assetTags, action.payload];
};
